module.exports = __webpack_public_path__ + "assets/view.fe42c42d.svg";